import { BasicFieldInputs } from '../components/BasicFieldInputs';
import { ActionIcon, Checkbox, Group, Stack, Text } from '@mantine/core';
import { CustomInput } from '../../CustomInput';
import { IconTrash } from '@tabler/icons-react';
import { useIntl } from 'react-intl';
import { PhotoFetchModal } from '../components/PhotoFetchModal';
import { ImageFile } from './types';
import { ReImportButton } from '../components/ReImportButton';

export const ImagePickerField = ({
  field,
  setField,
}: {
  field: any;
  setField: (field: any) => void;
}) => {
  const intl = useIntl();

  const handlePhotosAdded = (images: ImageFile[], folderPath: string) => {
    setField({
      ...field,
      availableImages: images || [],
      folderPath: folderPath,
    });
  };

  const handleImagesImported = (images: ImageFile[]) => {
    setField({
      ...field,
      availableImages: images || [],
      imagesImportedAt: Date.now(),
    });
  };

  return (
    <Stack gap="md">
      <BasicFieldInputs
        fields={['label', 'description']}
        fieldValues={field}
        requiredFields={['label']}
        onChange={(key, value) => setField({ ...field, [key]: value })}
      />

      <CustomInput
        type="number"
        value={field.maxSelection || 1}
        name="maxSelection"
        label={intl.formatMessage({ id: 'maxSelection' })}
        onChange={(value) => setField({ ...field, maxSelection: value || 1 })}
      />

      <Checkbox
        label={intl.formatMessage({ id: 'imagesAutoImport' })}
        checked={
          field.imagesAutoImport !== undefined ? field.imagesAutoImport : true
        }
        onChange={(event) =>
          setField({ ...field, imagesAutoImport: event.currentTarget.checked })
        }
      />

      <PhotoFetchModal onPhotosAdded={handlePhotosAdded} />

      {field.folderPath && (
        <ReImportButton
          folderPath={field.folderPath}
          onImagesImported={handleImagesImported}
          size="xs"
        />
      )}

      {(field.availableImages || []).length > 0 && (
        <Group justify="flex-end" align="center">
          <Text size="sm" c="dimmed">
            {intl.formatMessage(
              { id: 'totalImagesImported' },
              { count: (field.availableImages || []).length }
            )}
          </Text>
          <ActionIcon
            variant="default"
            onClick={() => {
              setField({
                ...field,
                availableImages: [],
              });
            }}
            title={intl.formatMessage({ id: 'clearAll' })}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      )}
    </Stack>
  );
};
